






import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import { WidgetMixin, TextMixin } from "./mixins";

@Component
export default class WCheckIn extends Mixins(WidgetMixin, TextMixin) {
  @Prop({ type: String, required: true })
  value!: string;

  get computedValue() {
    return this.getVariable(this.value);
  }

  get date() {
    const date = this.computedValue;
    return date
      ? new Date(date).toLocaleDateString()
      : this.$t("message.never");
  }
}
